import React from 'react'
import {Navigation} from '../components/Navigation'
import {Placeholder, Table} from 'semantic-ui-react'
import { useSelector } from 'react-redux'
import { useFirestore, useFirestoreConnect } from 'react-redux-firebase'
import {default as Lotteryrow} from '../components/storelocator/lotteryrow.js'
import {default as StorelistPopup} from '../components/storelocator/storelist.js'
import {default as Lotterylist} from '../components/storelocator/lotterylist.js'
import {Route} from '../components/Router.js'

export default function Storelocator() {
  return (
    <Navigation title="Store-Locator" icon="location arrow">
        <Route path="/storelocator/" exact={true} component={Lotterylist} />
        <Route path="/storelocator/stores/:lotteryId/:filter?" component={StorelistPopup} />
    </Navigation>
  )
}